import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import OutsideClick from 'components/OutsideClick';
import FilterSectionContext from 'contexts/FilterSectionContext';
import React, { FC, useState } from 'react';
import { Popper } from 'react-popper';
import PopoverHeader from './PopoverHeader';

interface Props {
  title: string;
  open: boolean;
  onClose: () => void;
  onReset: () => void;
  onConfirm: () => void;
  confirmBtnText: string;
}

const FilterPopover: FC<Props> = ({
  title,
  open,
  onClose,
  onReset,
  onConfirm,
  confirmBtnText,
  children,
}) => {
  const { translate } = useTranslator(['buttons']);
  const [sectionOpen, setSectionOpen] = useState<string | null>(null);

  const handleSectionOpenChange = (nextOpen: string | null): void => {
    setSectionOpen(nextOpen);
  };

  const handleSectionClose = (): void => {
    setSectionOpen(null);
  };

  const handlePopoverClose = (): void => {
    setSectionOpen(null);
    onClose();
  };

  const handleReset = (): void => {
    setSectionOpen(null);
    onReset();
  };

  const handleConfirm = (): void => {
    setSectionOpen(null);
    onConfirm();
  };

  const filterSectionContext = {
    sectionOpen,
    setSectionOpen: handleSectionOpenChange,
  };

  return (
    <Popper placement="bottom-start">
      {({ ref, style, placement }): React.ReactNode => {
        return open ? (
          <div
            ref={ref}
            className="bgd-white-2 b-3 font-size-4 black-2 oh"
            style={{
              ...style,
              width: '24rem',
              top: '8px',
              zIndex: 2,
            }}
            data-placement={placement}
          >
            <OutsideClick onOutsideClick={handlePopoverClose}>
              <FilterSectionContext.Provider value={filterSectionContext}>
                <PopoverHeader
                  title={sectionOpen || title}
                  onClose={handlePopoverClose}
                  onBack={handleSectionClose}
                  showBackArrow={sectionOpen !== null}
                />
                <div className="oh" style={{ height: '400px' }}>
                  {children}
                </div>
                <div className="row justify-between bt-2 px4 py3 bgd-white-2">
                  <Button
                    id="rfi-filter-list-reset"
                    variant="tertiary"
                    onClick={handleReset}
                  >
                    {translate('buttons:reset')}
                  </Button>
                  <Button
                    id="rfi-filter-list-apply"
                    variant="primary"
                    onClick={handleConfirm}
                  >
                    {confirmBtnText}
                  </Button>
                </div>
              </FilterSectionContext.Provider>
            </OutsideClick>
          </div>
        ) : null;
      }}
    </Popper>
  );
};

export default FilterPopover;
